export { default as PurchasedWorkshops } from './PurchasedWorkshops';
export { default as PurchasedWorkshopDetail } from './PurchasedWorkshopDetail';
